import { match } from 'ts-pattern'

import type {
  ServiceGetByIdResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { RecapPoktanQueryResult } from './dto'
import type { RecapPoktan, RecapPoktanMeta } from './types'

import { toRecords } from './dto'

const RECAP_POKTAN_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['recap_poktan', key] as const

interface GetRecapParams {
  region: 'national' | 'province' | 'city' | 'district'
  province_code?: string
  city_code?: string
  district_code?: string
}

type RecapPoktanApiResponse = ServiceGetByIdResponse<RecapPoktan> & {
  meta?: RecapPoktanMeta
}

const getRecap = (
  params: GetRecapParams
): ServiceQueryOptionType<RecapPoktanQueryResult> => ({
  queryKey: RECAP_POKTAN_QUERY_KEY(params),
  queryFn: async () => {
    try {
      const path = match(params.region)
        .with('province', () => `/province/${params.province_code}`)
        .with(
          'city',
          () => `/province/${params.province_code}/city/${params.city_code}`
        )
        .with(
          'district',
          () =>
            `/province/${params.province_code}/city/${params.city_code}/district/${params.district_code}`
        )
        .otherwise(() => '')

      const res = await api.get<RecapPoktanApiResponse>(
        `/report/extension-personnel-main/recap-poktan-type${path}`
      )

      return toRecords(res.data)
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const recapPoktan = {
  queryKey: RECAP_POKTAN_QUERY_KEY,
  getRecap
}
